import { useNavigate } from '@solidjs/router';
import Disc3 from 'lucide-solid/icons/disc-3';
import Shuffle from 'lucide-solid/icons/shuffle';
import { createEffect } from 'solid-js';
import { Transition } from 'solid-transition-group';
import { BrandBackground } from '~/components/layout/BrandBackground';
import { Button } from '~/components/ui';
import { useAuth } from '~/hooks/auth/useAuth';
import { LandingLayout } from '~/layouts/AppLayout';

export default function Home() {
  const navigate = useNavigate();
  const { isAuthenticated, isAuthLoading } = useAuth();

  // Rediriger automatiquement vers /mixtapes si l'utilisateur est connecté
  createEffect(() => {
    if (isAuthenticated() && !isAuthLoading()) {
      navigate('/mixtapes');
    }
  });

  const handleStart = () => {
    if (isAuthenticated()) {
      navigate('/mixtapes');
    } else {
      navigate('/login');
    }
  };

  return (
    <LandingLayout>
      <BrandBackground />
      <Transition name="fade" appear>
        <div class="relative z-10 flex flex-col justify-center items-center gap-10">
          <div class="text-2xl leading-relaxed">L'art du mix, simplifié.</div>
          <h1 class="max-6-xs text-9xl text-primary font-bold tracking-tight text-shadow-highlight">
            Quixtape
          </h1>
          <div class="flex flex-col justify-center items-center">
            <div class="flex flex-col items-center text-center max-w-2xl px-4 space-y-2">
              <p class="uppercase tracking-widest text-sm text-primary-lighter flex items-center gap-2 [&_svg]:size-4">
                Quick <Shuffle /> Mixtape
              </p>
              <p class="text-accent leading-relaxed">
                Uploadez vos morceaux, laissez la magie opérer. Quixtape analyse, synchronise et
                assemble vos tracks en mixtapes fluides, prêtes à partager sur Nina.fm.
              </p>
            </div>
          </div>
          <Button size="xl" effect="magic" onClick={handleStart}>
            <Disc3 class="group-hover:animate-spin" />
            Commencer
          </Button>
        </div>
      </Transition>
    </LandingLayout>
  );
}
